import React from 'react';

export default function FormSection({ data, handleChange, handleImageChange }) {
  return (
    <div className="bg-white shadow-lg rounded-lg p-6 md:max-w-2xl w-full mx-auto">
      <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">
        Cover Letter Builder / منشئ خطاب الغلاف 
      </h2>
      <form className="space-y-6">
        {/* Company Name */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Company Name / اسم الشركة
          </label>
          <textarea
            type="text"
            name="companyName"
            value={data.companyName}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Greeting */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Greeting / تحية
          </label>
          <input
            type="text"
            name="greeting"
            value={data.greeting}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Recipient Name */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Recipient Name / المرسل إليه
          </label>
          <textarea
            type="text"
            name="recipientName"
            value={data.recipientName}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Salutation */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Salutation / التحية
          </label>
          <input
            type="text"
            name="salutation"
            value={data.salutation}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Message */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Message / الرسالة
          </label>
          <textarea
            name="message"
            value={data.message}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
            rows="4"
          />
        </div>

        {/* Wishes */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Wishes / الأمنيات
          </label>
          <input
            type="text"
            name="wishes"
            value={data.wishes}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Closing */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Closing / الإغلاق
          </label>
          <textarea
            type="text"
            name="closing"
            value={data.closing}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Footer Details */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Footer Text 1 / نص التذييل 1
          </label>
          <textarea
            name="footerLine1"
            value={data.footerLine1}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
            rows="2"
          />
        </div>

        <div>
          <label className="block text-md font-medium text-gray-700">
            Footer Text 2 / نص التذييل 2
          </label>
          <textarea
            name="footerLine2"
            value={data.footerLine2}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
            rows="2"
          />
        </div>

        <div>
          <label className="block text-md font-medium text-gray-700">
            Footer Text 3 / نص التذييل 3
          </label>
          <textarea
            name="footerLine3"
            value={data.footerLine3}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
            rows="2"
          />
        </div>

        <div>
          <label className="block text-md font-medium text-gray-700">
            Footer Text 4 / نص التذييل 4
          </label>
          <textarea
            name="footerLine4"
            value={data.footerLine4}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
            rows="2"
          />
        </div>

        {/* Social Media Links */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Facebook Link / رابط فيسبوك
          </label>
          <input
            type="text"
            name="facebookLink"
            value={data.facebookLink}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        <div>
          <label className="block text-md font-medium text-gray-700">
            Twitter Link / رابط تويتر
          </label>
          <input
            type="text"
            name="twitterLink"
            value={data.twitterLink}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        <div>
          <label className="block text-md font-medium text-gray-700">
            Instagram Link / رابط إنستغرام
          </label>
          <input
            type="text"
            name="instagramLink"
            value={data.instagramLink}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Contact Number */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Contact Number / رقم الاتصال
          </label>
          <input
            type="text"
            name="contactNumber"
            value={data.contactNumber}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>

        {/* Company Logo */}
        <div>
          <label className="block text-md font-medium text-gray-700">
            Change Company Logo / تغيير شعار الشركة
          </label>
          <input
            type="file"
            name="logoImage"
            onChange={(e) => handleImageChange(e, 'logoImage')}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
          />
        </div>
      </form>
    </div>
  );
}
